<template>
    <div class="bm-container flex-column">
        <m-header />
        <div class="dis-flex flex mb20" >
            <silder-bar />

            <div class="main-content">
                <keep-alive :include="keepAliveArray">
                    <router-view></router-view>
                </keep-alive>
            </div>
        </div>
<!--        <m-footer />-->
    </div>
</template>

<script>
    import MHeader from '@/components/MHeader'
    import SilderBar from '@/components/SilderBar'
    import MFooter from  '@/components/MFooter'

    export default {
        name: 'Manage',
        data() {
            return {
                keepAliveArray: [],
            }
        },
        components: {
            MHeader,
            SilderBar,
            MFooter,
        },
        mounted() {
        },
        computed: {
            userInfo() {
                let userInfo = JSON.parse(this.$store.state.userInfo) || {}
                return userInfo
            }
        },
        created() {
        },
        methods: {

        }
    }
</script>

<style scoped lang="stylus">
    .flex-column
        display flex
        flex-direction column
    .bm-container {
        box-sizing: border-box
        width: 100%
        height: 100%;
        overflow hidden
        background-color #F5F5F5
    }

    .dis-flex {
        display: -ms-flex;
        display: flex;
        flex 1
    }

    .flex {
        -ms-flex: 1;
        flex: 1;
        min-width: 0;
        min-height: 0;
    }

    .main-content
        -ms-flex: 1;
        flex: 1;
        min-width: 0;
        min-height: 0;
        height: 100%
        background #F5F5F5
        overflow-y auto
        padding-left 20px
        display flex

    .mb20 {
        margin-bottom 20px
    }


</style>
